import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { key: String, expanded: { type: Boolean, default: true } }

  connect() {
    const saved = localStorage.getItem(this.keyValue)
    this.expandedValue = saved !== null ? saved === "true" : true
    this.render()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    localStorage.setItem(this.keyValue, this.expandedValue)
    this.render()
  }

  render() {
    this.contentTarget.classList.toggle("hidden", !this.expandedValue)
    this.iconTarget.classList.toggle("rotate-90", this.expandedValue)
  }
}
